<ng-container infiniteScroll [infiniteScrollDistance]="0.5" [infiniteScrollContainer]="'.main-view'"
    [infiniteScrollThrottle]="50" [fromRoot]="true" (scrolled)="onCqScroll()">

    <!-- Empty State Message -->
    <div class="empty-state-container" *ngIf="!cqsInfo?.questions || cqsInfo?.questions?.length === 0">
        <div class="empty-state-content">
            <div class="empty-state-icon">
                <mat-icon>code</mat-icon>
            </div>
            <h3 class="empty-state-title">No Coding Questions Available</h3>
            <p class="empty-state-description">
                No coding questions found for the selected criteria.
                Try adjusting your filters or generate new questions.
            </p>
        </div>
    </div>

    <div class="mcq-card" *ngFor="let item of cqsInfo?.questions; let i = index" id="cq-card-{{i}}{{fromView}}"
        [class.flash-highlight]="item._highlight">
        <div class="undo-section" *ngIf="item.selected && !(item.displayText?.length || item.error)">
            <app-undo class="undo-comp" [undoItem]="undoSelectedItem"
                (undoAction)="undoSelectedIQuestion(item)"></app-undo>
        </div>

        <div class="mcq-header">
            <div class="mcq-header-left">
                <mat-checkbox class="mcq-select-checkbox" [checked]="item._selected"
                    (change)="onSelectChange(item, $event)" (click)="$event.stopPropagation()"
                    [disabled]="item.selected" *ngIf="showCheckboxes" color="primary"></mat-checkbox>
                <div class="question-identity">
                    <span class="q-label">Q{{i+1}}</span>
                </div>
                <span class="difficulty-chip" [ngClass]="item.difficultyLevel?.toLowerCase() || 'medium'">
                    <mat-icon class="difficulty-icon">signal_cellular_alt</mat-icon>
                    {{ item.difficultyLevel | difficultyLevel }}
                </span>

                <button mat-icon-button [matMenuTriggerFor]="cqMenu" class="more-actions-btn"
                    *ngIf="!item.regenerate && !item.selected && !cqsInfo?.isPreview && (cqsInfo?.from === 'questionsList' || cqsInfo?.category === 'GENERATED' || cqsInfo?.category === 'PREVIOUSLYGENERATED' || cqsInfo?.category === 'SELECTED')"
                    (click)="setMenuItem(item); $event.stopPropagation()">
                    <mat-icon>more_horiz</mat-icon>
                </button>
            </div>

            <div class="mcq-header-right">
                <button mat-button class="select-btn"
                    *ngIf="cqsInfo?.category === 'GENERATED' || cqsInfo?.category === 'PREVIOUSLYGENERATED'"
                    (click)="$event.stopPropagation(); addCqToAssessment(item);"
                    [disabled]="item.regenerate || item.selected" [ngClass]="{'is-selected': item.selected}">
                    <mat-icon>{{ item.selected ? 'check' : 'add' }}</mat-icon>
                    {{ item.selected ? 'Selected' : 'Select' }}
                </button>

                <button mat-button class="remove-btn" *ngIf="cqsInfo?.category === 'SELECTED'"
                    (click)="$event.stopPropagation(); removeSelectedCQ.emit(item);">
                    <mat-icon>remove_circle_outline</mat-icon>
                    Remove
                </button>

                <button mat-icon-button class="expand-btn" (click)="toggleExpand(item)"
                    [disabled]="item.regenerate || item.selected">
                    <mat-icon class="expand-icon" [class.is-expanded]="item.expanded">expand_more</mat-icon>
                </button>
            </div>
        </div>

        <div class="mcq-body"
            [ngClass]="{'dimmed': item.selected && !(item.displayText?.length || item.error), 'regenerate-center': item.regenerate}">
            <ng-container *ngIf="item.regenerate; else normalContent">
                <app-generate-loader [displayText]="displayText" [genearateSuccess]="generateSuccess"
                    [reGenerate]="true"></app-generate-loader>
            </ng-container>

            <ng-template #normalContent>
                <div class="insight-board">
                    <div class="section-label-row no-border">
                        <div class="section-label">
                            <mat-icon class="section-icon">description</mat-icon>
                            <span>Question Content</span>
                        </div>
                        <div class="section-actions">
                            <ng-container *ngIf="!item?.question_edit_clicked; else textEditActions">
                                <button mat-icon-button class="edit-btn"
                                    *ngIf="cqsInfo.from !=='preview' && !cqsInfo.isPreview"
                                    (click)="onQuestionEditClick(item, i)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </ng-container>
                            <ng-template #textEditActions>
                                <div class="header-action-group">
                                    <button mat-button class="cancel-btn-header"
                                        (click)="onQuestionEditCancelBtnClick(item)">Cancel</button>
                                    <button mat-flat-button color="primary" class="save-btn-header"
                                        (click)="onEditDone(item, i)" [disabled]="item.regenerate">Save</button>
                                </div>
                            </ng-template>
                        </div>
                    </div>

                    <div class="question-text-container">
                        <ng-container *ngIf="!item?.question_edit_clicked; else textEditor">
                            <div class="question-text" [innerHTML]="formatQuestionText(item.questionText)"></div>
                        </ng-container>
                        <ng-template #textEditor>
                            <div class="edit-question-block inplace">
                                <angular-editor class="edit-question-textarea" (click)="$event.stopPropagation()"
                                    (keydown)="$event.stopPropagation()" (keyup)="$event.stopPropagation()"
                                    [(ngModel)]="item.temp_questionText" [config]="editorEditConfig" id="q-text-{{i}}">
                                </angular-editor>
                            </div>
                        </ng-template>
                    </div>

                    <div class="tags-container" *ngIf="!item?.question_edit_clicked">
                        <div class="language-list" *ngIf="item.questionSignatures?.length">
                            <span class="tag-badge language" *ngFor="let lang of item.questionSignatures">
                                <mat-icon>code</mat-icon>
                                {{ lang?.functionSignature?.code_language_name ||
                                lang?.functionSignature?.code_language }}
                            </span>
                        </div>
                        <div class="subtopics-list" *ngIf="item.codingSubTopics?.length">
                            <span class="tag-badge subtopic" *ngFor="let topic of item.codingSubTopics">
                                <mat-icon>folder</mat-icon>
                                {{ topic.name }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="coding-section" *ngIf="item.expanded">
                    <!-- Initial Code Block -->
                    <div class="code-block-container">
                        <div class="section-label-row">
                            <div class="section-label">
                                <mat-icon class="section-icon">settings_code</mat-icon>
                                <span>Initial Code</span>
                            </div>
                            <div class="section-actions">
                                <ng-container *ngIf="!item?.initial_edit_clicked; else initialEditActions">
                                    <button mat-icon-button class="edit-btn"
                                        *ngIf="cqsInfo.from !=='preview' && !cqsInfo.isPreview"
                                        (click)="onInitialEditClick(item, i)"
                                        [disabled]="item.regenerate || item.answer_edit_clicked">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </ng-container>
                                <ng-template #initialEditActions>
                                    <div class="header-action-group">
                                        <button mat-button class="cancel-btn-header"
                                            (click)="onInitialEditCancelBtnClick(item, i)">Cancel</button>
                                        <button mat-flat-button color="primary" class="save-btn-header"
                                            (click)="onEditDone(item, i)" [disabled]="item.regenerate">Save</button>
                                    </div>
                                </ng-template>
                            </div>
                        </div>

                        <div class="ide-wrapper">
                            <div class="ide-header">
                                <div class="dots-group">
                                    <span class="dot red"></span>
                                    <span class="dot yellow"></span>
                                    <span class="dot green"></span>
                                </div>
                                <div class="file-name">
                                    <mat-icon>terminal</mat-icon>
                                    <span>initial_code</span>
                                </div>
                                <div class="ide-status" *ngIf="!item.initial_edit_clicked">READ-ONLY</div>
                            </div>
                            <div class="app-ace-editor" id="preview-ace-editor-{{i}}{{fromView}}" #verifyCodeEditor>
                            </div>
                        </div>
                    </div>

                    <!-- Answer Section -->
                    <div class="code-block-container answer">
                        <div class="section-label-row header-with-controls">
                            <div class="section-label">
                                <mat-icon class="section-icon">verified_user</mat-icon>
                                <span>House Answer</span>
                            </div>

                            <div class="header-controls-group">
                                <mat-form-field appearance="outline" class="language-select compact"
                                    subscriptSizing="dynamic">
                                    <mat-label>Language</mat-label>
                                    <mat-select (selectionChange)="selectedCodingLang($event, item, i)"
                                        [(value)]="item.selectedLang" [disabled]="item.regenerate">
                                        <mat-option [value]="lang?.functionSignature?.language_id"
                                            *ngFor="let lang of item.questionSignatures; let langIdx = index">
                                            {{(lang?.functionSignature?.code_language_name ||
                                            lang?.functionSignature?.code_language) | titlecase}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <button mat-flat-button class="run-code-btn compact" (click)="runCode(item);"
                                    [disabled]="item.regenerate">
                                    <mat-icon *ngIf="btnRunCodeTxt === 'Run Code'">play_circle</mat-icon>
                                    <mat-spinner class="run-spinner-small" *ngIf="btnRunCodeTxt !== 'Run Code'"
                                        [diameter]="16"></mat-spinner>
                                    <span>{{btnRunCodeTxt === 'Run Code' ? 'Run' : 'Running'}}</span>
                                </button>
                            </div>

                            <div class="section-actions">
                                <ng-container *ngIf="!item?.answer_edit_clicked; else answerEditActions">
                                    <button mat-icon-button class="edit-btn"
                                        *ngIf="cqsInfo.from !=='preview' && !cqsInfo.isPreview"
                                        (click)="onAnswerEditClick(item, i)"
                                        [disabled]="item.regenerate || item.initial_edit_clicked">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </ng-container>
                                <ng-template #answerEditActions>
                                    <div class="header-action-group">
                                        <button mat-button class="cancel-btn-header"
                                            (click)="onAnswerEditCancelBtnClick(item, i)">Cancel</button>
                                        <button mat-flat-button color="primary" class="save-btn-header"
                                            (click)="onEditDone(item, i)" [disabled]="item.regenerate">Save</button>
                                    </div>
                                </ng-template>
                            </div>
                        </div>

                        <!-- Test Results -->
                        <div class="test-results"
                            *ngIf="item?.questionSignatures[this.sourceCodefindIndex]?.testResults">
                            <div class="results-header">
                                <mat-icon>bug_report</mat-icon>
                                <span>Execution Results</span>
                            </div>
                            <div class="run-results-content">
                                {{item?.questionSignatures[this.sourceCodefindIndex]?.testResults}}
                            </div>
                        </div>

                        <div class="ide-wrapper">
                            <div class="ide-header">
                                <div class="dots-group">
                                    <span class="dot red"></span>
                                    <span class="dot yellow"></span>
                                    <span class="dot green"></span>
                                </div>
                                <div class="file-name active">
                                    <mat-icon>code</mat-icon>
                                    <span>solution</span>
                                </div>
                            </div>
                            <div class="app-ace-editor" id="coding-ans-ace-editor-{{i}}{{fromView}}" #answerCodeEditor>
                            </div>
                        </div>

                    </div>
                </div>
            </ng-template>
        </div>
    </div>

    <mat-menu #cqMenu="matMenu">
        <button mat-menu-item
            *ngIf="cqsInfo?.from === 'questionsList' || cqsInfo?.category === 'GENERATED' || cqsInfo?.category === 'PREVIOUSLYGENERATED' || cqsInfo?.category === 'SELECTED'"
            (click)="$event.stopPropagation(); onEditClick(menuItem)">
            <mat-icon>edit</mat-icon> Edit
        </button>
        <button mat-menu-item
            *ngIf="cqsInfo?.from === 'questionsList' || cqsInfo?.category === 'GENERATED' || cqsInfo?.category === 'PREVIOUSLYGENERATED'"
            (click)="$event.stopPropagation(); onDuplicate(menuItem)">
            <mat-icon>content_copy</mat-icon> Duplicate
        </button>
        <button mat-menu-item
            *ngIf="cqsInfo?.from === 'questionsList' || cqsInfo?.category === 'GENERATED' || cqsInfo?.category === 'PREVIOUSLYGENERATED'"
            (click)="$event.stopPropagation(); onDelete(menuItem)">
            <mat-icon>delete</mat-icon> Delete
        </button>
        <button mat-menu-item *ngIf="cqsInfo?.category === 'GENERATED'"
            (click)="$event.stopPropagation(); openRegenerateDialog(menuItem)">
            <mat-icon>autorenew</mat-icon> Regenerate
        </button>
    </mat-menu>
</ng-container>